/** Created by azhou on 2019/3/11.*/
<template>
  <ul class="list-item">
    <li class="w-50 list-item-col">
      <el-checkbox v-model="Itemize.checked" class="mr-2" v-show="Itemize.is_verify===0"/>
      &yen; {{(Itemize.money / 100).toFixed(2)}}
    </li>
    <li class="w-50 list-item-col">&yen; {{(Itemize.money_end / 100).toFixed(2)}}</li>
    <li class="w-50 list-item-col">{{Itemize.do_time | formatTimestamp(1)}}</li>
    <li class="w-50 list-item-col" v-if='!isAdmin'>{{Itemize.create_ticket_time | formatTimestamp(1)}}</li>
    <li class="w-50 list-item-col" v-if='!isAdmin'>{{Itemize.ticket_opening_time | formatTimestamp(1)}}</li>
    <li class="w-50 list-item-col" v-if="Itemize.card && !isAdmin">******{{Itemize.card.substr(Itemize.card.length - 4)}}</li>
    <li class="w-50 list-item-col" v-if="isAdmin">{{Itemize.truename}}</li>
    <li class="w-50 list-item-col">
      &yen;{{((Itemize.money - Itemize.money_end) / 100).toFixed(2)}}
      <el-popover placement="right" trigger="hover" class="ml-1 h7">
        <p>订单号：{{Itemize.order_no}}</p>
        <span slot="reference"><i class="el-icon-info text-info"></i></span>
      </el-popover>
    </li>
    <li class="w-50 list-item-col" v-if="!isAdmin"
        :class="[Itemize.is_verify===1 ? 'text-success' : 'text-danger' ]">
      {{verifyArr[Itemize.is_verify]}}
    </li>
  </ul>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'InvoiceItemize',
    props:{
      Itemize:{}
    },
    computed: {
      ...mapGetters(['storeInfo','isAdmin'])
    },
    data() {
      return {
        verifyArr:{
          0:'未开票',
          1:'已开票',
          2:'开票审核中',
        }
      }
    }
  }
</script>
